module.exports = __webpack_public_path__ + "static/img/logo.1958f8d2.png";